/**
 * Normalize backend base URLs from Vite env.
 * Prevents relative fetches like:
 *   testadmin-menioo.netlify.app/admin/admin-menioo-test.up.railway.app/...
 * when VITE_BACKEND_URL was set without https://
 */
export function normalizeBackendUrl(
  raw: string | undefined,
  fallback = 'http://localhost:3001'
): string {
  let url = (raw || fallback).trim().replace(/\/+$/, '');
  if (!url) url = fallback;
  if (!/^https?:\/\//i.test(url)) {
    url = `https://${url}`;
  }
  return url;
}
